import { ModelBase } from "../core/modelbase";

export class AuditAction extends ModelBase {
  aaKey: string;
  aaDescription: string;
  aaTimeStamp: Date;
  aaUsKey: string;
}
